import { Title, useAdaptive } from '@skillarea/lib-frontend';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Trans } from 'react-i18next';

import cx from 'classnames';

import styles from './Games.module.scss';

import dashboardStyles from '~/components/Dashboard/Dashboard.module.scss';
import { GameCard } from '~/components/GameCard/GameCard';
import { gameQueries } from '~/stores/gameStore';

export const Route = createFileRoute('/games/')({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(
      gameQueries.list({}, context.queryClient),
    );
  },
  component: GamesPage,
});

function GamesPage() {
  const { queryClient } = Route.useRouteContext();
  const { data } = useSuspenseQuery(gameQueries.list({}, queryClient));
  const games = data ? Object.values(data.items) : [];

  const { isMobile, isTablet } = useAdaptive();
  const size = isMobile ? 'xs' : isTablet ? 's' : 'm';

  return (
    <div className={styles.gamesPage}>
      <div className={styles.container}>
        <div className={dashboardStyles.dashboardContainer}>
          <Title
            className={cx(styles.title)}
            color="contrast"
            size={size}
            variant="benzin"
          >
            <Trans
              components={{
                accent: (
                  <Title
                    color="accent"
                    isInsertion
                    size={size}
                    variant="cormorant"
                  />
                ),
              }}
              i18nKey="chooseGame"
              ns="dashboard"
            />
          </Title>

          <section className={dashboardStyles.gamesSection}>
            <div className={dashboardStyles.gamesGrid}>
              {games.map((game) => (
                <GameCard {...game} key={game.id} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
